export default "__VITE_ASSET__7d1d97fb__"